import { htmlLanguageMap } from '../constants/languageHelpers'
import { HtmlLanguages, Languages } from '../interfaces/common'

export function getHtmlLanguage(lang: Languages): HtmlLanguages {
  return htmlLanguageMap[lang]
}
